import * as actionType from '../actionType'

export const changeHeaderTab = (tabName) => {
    return {
        type: actionType.SET_HEADER_TAB,
        value: tabName,
    }
}
